<template>
  <div>
    <div>
      <b-list-group class="ticket-list">
        <b-list-group-item class="flex-column align-items-start ticket">
          <b-row no-gutters>
            <b-col lg="6" cols="12" class="d-pl-2 mb-2 text-right">
              <div class="select_wrap">
                <label class="form-label">مرتب سازی بر اساس تاریخ</label>
                <v-select
                  :components="{ Deselect }"
                  :options="['asc', 'desc']"
                  label="title"
                  dir="rtl"
                  class="style-chooser"
                  @input="getTickets()"
                  v-model="orderFilter"
                >
                  <div slot="no-options">موردی یافت نشد</div>
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!orderFilter"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </b-col>
            <b-col lg="6" cols="12" class="d-pr-2 mb-2 text-right">
              <div class="select_wrap">
                <label class="form-label">دپارتمان</label>

                <v-select
                  :options="departments"
                  label="title"
                  dir="rtl"
                  @input="getTickets()"
                  class="style-chooser"
                  v-model="selectedDepartment"
                >
                  <div slot="no-options">موردی یافت نشد</div>
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!selectedDepartment"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col lg="6" cols="12" class="d-pl-2 mb-2">
              <div class="select_wrap">
                <label class="form-label">اولویت</label>
                <v-select
                  :options="priorities"
                  label="title"
                  dir="rtl"
                  @input="getTickets()"
                  placeholder="انتخاب وضعیت"
                  class="style-chooser"
                  v-model="selectedPriority"
                >
                  <div slot="no-options">موردی یافت نشد</div>
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!selectedPriority"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </b-col>
            <b-col lg="6" cols="12" class="d-pr-2 mb-2">
              <div class="select_wrap">
                <label class="form-label">وضعیت</label>
                <v-select
                  :options="statusList"
                  label="title"
                  dir="rtl"
                  @input="getTickets()"
                  class="style-chooser"
                  v-model="status"
                >
                  <div slot="no-options">موردی یافت نشد</div>
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!status"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
              </div>
            </b-col>
          </b-row>
        </b-list-group-item>
        <div v-if="ticketList.length > 0">
          <div v-for="(ticket, index) in ticketList" :key="index">
            <b-list-group-item
              :to="'/ticket-profile/' + ticket.uid"
              class="flex-column align-items-start ticket"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 ticket-title">
                  {{ ticket.subject }}
                  <b-badge pill variant="primary">{{
                    ticket.department.title
                  }}</b-badge>
                  <b-badge pill variant="warning" class="mr-2">{{
                    getTicketPriorityText(ticket.priority)
                  }}</b-badge>
                </h5>
                <small>
                  <b-button
                    disabled
                    :variant="getTicketStatusVariant(ticket.status)"
                    >{{ getTicketStatusText(ticket.status) }}</b-button
                  >
                  <b-icon
                    class="mr-4"
                    font-scale="1.2"
                    icon="chevron-left"
                    variant="dark"
                  ></b-icon>
                </small>
              </div>
              <small class="ticket-date">
                {{
                  new Date(ticket.created).toLocaleString("fa-ir", {
                    timeZone: "Asia/Tehran",
                  })
                }}
              </small>
            </b-list-group-item>
          </div>
        </div>
        <div class="text-center pt-5 pb-5" v-else>
          <b>شما تیکتی ندارید. برای ارتباط با پشتیبانی یک تیکت ثبت کنید</b>
        </div>
      </b-list-group>
      <div class="paginationNav">
        <b-row>
          <b-col class="mt-4">
            <div class="overflow-auto">
              <b-pagination-nav
                align="center"
                :link-gen="linkGen"
                :page-gen="pageGen"
                :number-of-pages="pages"
                v-model="page"
                use-router
              ></b-pagination-nav>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "all-tickets",
  props: {
    departments: {
      type: Array,
      description: "List of departments",
    },

    priorities: {
      type: Array,
      description: "List of priorities",
    },
  },

  data() {
    return {
      Deselect: {
        render: (createElement) => createElement("span", ""),
      },
      orderFilter: "asc",
      loading: false,
      ticketList: [],
      selectedDepartment: "",
      selectedPriority: {},

      status: "",
      statusList: [
        { key: "pending", title: "در حال بررسی" },
        { key: "resolved", title: "بسته شده" },
        { key: "answered", title: "جواب داده شده" },
      ],

      pages: 1,
      page: 1,
    };
  },

  mounted() {
    this.page = this.$route.params.page;
    this.getTickets();
  },

  methods: {
    linkGen(pageNum) {
      return `/support/${pageNum}`;
    },

    pageGen(pageNum) {
      return pageNum;
    },

    getTicketPriorityText(priority) {
      if (priority == 1) {
        return "کم";
      }
      if (priority == 2) {
        return "متوسط";
      }
      if (priority == 3) {
        return "زیاد";
      }
    },

    getTicketStatusText(status) {
      if (status == "pending") {
        return "در حال بررسی";
      }
      if (status == "answered") {
        return "پاسخ داده شده";
      }
      if (status == "resolved") {
        return "بسته شده";
      }
    },

    getTicketStatusVariant(status) {
      if (status == "pending") {
        return "warning";
      }
      if (status == "answered") {
        return "success";
      }
      if (status == "resolved") {
        return "primary";
      }
    },

    getTickets() {
      this.loading = true;

      let query = `?created=${this.orderFilter}`;

      if (
        this.selectedDepartment != null &&
        this.selectedDepartment.uid != undefined
      ) {
        query += `&department=${this.selectedDepartment.uid}`;
      }

      if (
        this.selectedPriority != null &&
        this.selectedPriority.id != undefined
      ) {
        query += `&priority=${this.selectedPriority.id}`;
      }

      if (this.status != null && this.status.key != undefined) {
        query += `&status=${this.status.key}`;
      }

      axios({
        method: "get",
        url:
          process.env.VUE_APP_TICKETSERVICE_URL +
          "/api/tickets/list/" +
          this.page +
          query,
        //baseURL: process.env.VUE_APP_BASE_URL,
        crossDomain: true,
        headers: {
          //'Access-Control-Allow-Origin': '*',
          Authorization: "Bearer " + this.$store.getters.token,
        },
      })
        .then((response) => {
          this.pages = response.data.info.totalPages;
          this.ticketList = response.data.list;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
        });
    },
  },
};
</script>

<style lang="scss">
@media (max-width: 991px) {
  .form-label {
    text-align: right;
  }

  .select_wrap {
    direction: rtl;
    text-align: right;
  }
}

@media (min-width: 991px) {
  .desktop-flex {
    display: flex;
  }

  .d-mr-4 {
    margin-right: 1.5rem !important;
  }

  .d-ml-4 {
    margin-left: 1.5rem !important;
  }

  .d-pr-0 {
    padding-right: 0 !important;
  }

  .d-pl-0 {
    padding-left: 0 !important;
  }
}

.primary-button {
  padding: 7px 16px;
  border-radius: 4px;
  background-color: #2a6ae3;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
}

.primary-button:hover {
  color: #ffffff;
}

.tickets-header {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: rgba(0, 0, 0, 0.87);
}

.ticket-list {
  .list-group-item.active {
    text-decoration: none;
    background-color: transparent;
    border-color: transparent;
  }
}

.ticket {
  .btn-success {
    padding: 4px 8px;
    border-radius: 4px;
    border: solid 1px #0fa956;
    background-color: rgba(13, 203, 101, 0.05);
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #0fa956;
  }

  .btn-warning {
    padding: 4px 8px;
    border-radius: 4px;
    border: solid 1px #dc530e;
    background-color: rgba(220, 83, 14, 0.1);
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #dc530e;
  }

  .btn-primary {
    padding: 4px 8px;
    border-radius: 4px;
    border: solid 1px #2969e3;
    background-color: rgba(41, 105, 227, 0.2);
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #204cda;
  }
}
</style>
